var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadOutline2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2929 10.2928C17.6835 9.90235 18.3167 9.90239 18.7072 10.2929C19.0977 10.6835 19.0976 11.3167 18.7071 11.7072L12.7063 17.7072C12.3158 18.0976 11.6826 18.0976 11.2921 17.7071L5.29212 11.7071C4.9016 11.3166 4.9016 10.6834 5.29212 10.2929C5.68265 9.90237 6.31581 9.90237 6.70634 10.2929L10.9992 14.5858V3C10.9992 2.44771 11.4469 2 11.9992 2C12.5515 2 12.9992 2.44771 12.9992 3V14.586L17.2929 10.2928Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.999 20L4.99902 20C4.44674 20 3.99902 20.4477 3.99902 21C3.99902 21.5523 4.44674 22 4.99902 22L18.999 22C19.5513 22 19.999 21.5523 19.999 21C19.999 20.4477 19.5513 20 18.999 20Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadOutline2);
export default __webpack_public_path__ + "static/media/download_outline (2).442e13349ea4c89ad0b72fd5aa5edf28.svg";
export { ForwardRef as ReactComponent };